// @flow
import environment from '../../../environment/index';
import { postCreator, putCreator, deleteCreator } from '../../../http';

export type EditProfileRequest = {
  phone: string;
  description: string;
  fisrtName: string;
  lastName: string;
  image: string;
};

export type UploadImageResponse = {
  +type: string;
  +id: string;
  +resourceGroup: string;
  +resourceId: string;
  +url: string;
};

export const endpoints = Object.freeze({
  PUT_PROFILE: `${environment.apiUrl}/preferences/profile`,
  UPLOAD_IMAGE: `${environment.apiUrl}/image/upload`,
});

export const putProfileApi = postCreator(fetch, endpoints.PUT_PROFILE); //change backend to PUT
export const uploadImageApi = postCreator(fetch, endpoints.UPLOAD_IMAGE);



// WEBPACK FOOTER //
// ./src/modules/preferences/edit-profile/api.js